import * as types from './types';
import { set, lensPath, view, omit, isEmpty } from 'ramda';
import { ContactsService } from '../services/contacts.service';
import { SET_MAIN_NAV_ACTIVE } from '../../../store/app/types';
import { GroupService } from '../../../dt-plugins/groups/groups.service';
import { HttpClient, MHTTPCL } from '../../../services/http/http-client';
import { relatedContactService } from '../../booking/services/artists/related-contacts.service';
import { UPDATE_RELATED_CONTACT, DELETE_RELATED_CONTACT } from '../../../dt-plugins/add-contact-relation/store';
import { createContactDetails } from '../models/contact-details.model';
import { contactGroupActions } from "./groups/actions";
import { contactFileActions } from "./files/actions";

import { InvoicesService } from '../../../modules/accounting/services/invoices.service.js'
import { getNavTabModule } from '../../../dt-plugins/sidewindow/nav-tab';
import router from '../../../router';
import { setMainNavInactive } from '../../../store/app/mutations';
import { ContactFuncs } from '../models/contacts.model';
import { ContactService } from '../../../dt-plugins/add-contact-relation/contact.service';
import { prop } from 'ramda';

const NavTabModule = getNavTabModule(types.ContactDetails, 'contactDetails');
const contact_idr = () => router.currentRoute.params.contact_id;

export const actions = {
  ...NavTabModule.implementActions(
    'contact_id',
    'contact_list/contact_id/tab',
    'contact_list',
    () => router,
    'contacts',
    (value, key) => {
      // return {
      //   title: `Contact - ${key}`,
      //   full_title: `Contact - ${key}`
      // }
      return {
        title: value?.contact?.company_name || value?.contact?.company_legalname || value?.contact?.first_name || value?.contact?.last_name ? ContactFuncs.getName(value.contact) : key,
        full_title: value?.contact?.company_name || value?.contact?.company_legalname || value?.contact?.first_name || value?.contact?.last_name ? ContactFuncs.getName(value.contact) : key,
      }
    }
  ),
  // Show Sidewindow
  async [types.ContactDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, contact, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "contact_id";
    const itemName = "contact";
    const item = payload[itemName];

    if (!item) {
      return;
    }
    console.log('mdsir: 1');
    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "contactDetails";
    const DetailsAction = types.ContactDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }
    console.log('mdsir: 2');
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const contactDetails = await Promise.all([
      ContactsService.findContactDetails({
        contact_id: contact.contact_id
      }),
      ContactsService.findCustomFields({ contact_id: contact.contact_id }),
    ]).then(res => {
      console.log(res);
      return {
        ...(res[0].data || {}),
        fields: (res[1].data || [])
      };
    })
    // dispatch(types.ContactAccountingInfo.FETCH.ALL, contact);
    const accountingInfo = await HttpClient.mergeRequests([ContactsService.findAccountingInfo({
      contact_id: contact.contact_id
    }), ContactsService.findInvoiceTab({
      contact_id: contact.contact_id
    })]);

    const detailsData = {
      ...contactDetails,
      ...accountingInfo,
    }

    console.log('contactDetais:mdsir', detailsData);

    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, contact) => {
        return {
          ...contact,
          ...detailsData,
          loading: false,
        };
      }
    );
  },
  async [types.ContactDetails.UPDATE.MULTIPLE]({ dispatch, getters, commit }, payload) {
    const { contact_id, contact, ...rest } = payload;
    const contactID = contact_id ? contact_id
      : contact?.contact?.contact_id ? contact?.contact?.contact_id
        : contact_idr();

    console.log({ payload, rest, contact, contactID });

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(contactID, contactDetailsObj => {
      return {
        ...contactDetailsObj,
        ...rest,
        contact,
      };
    });

    // console.log('Total Count of Contacts in Contacts List', getters.contactsData?.contacts?.length);

    // Update Contacts Data When the Contact_id exists there
    if (getters.contactsData.contacts && !isEmpty(contact)) {
      // console.log('Trying to update contact in contactsData');
      const contacts = getters.contactsData.contacts.map(e => {
        // console.log(`Comparing ${e.contact_id} with ${contactID}`);

        if (`${e.contact_id}` === `${contactID}`) {
          console.log({
            oldContact: e,
            updatedContact: {
              ...e,
              ...contact
            }
          })
          return {
            ...e,
            ...contact
          };
        }
        return e;
      });
      // console.log({ 'actions.js:129 contacts': contacts });

      commit(types.ContactsData.SET.ALL, {
        ...getters.contactsData,
        contacts
      });
    }
  },
  async [types.ContactsData.DELETE.SINGLE]({ dispatch, getters, commit }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    
    const { contact_id, noDatabaseUpdate } = payload;

    commit(types.ContactsData.SET.ALL, {
      ...getters?.contactsData,
      contacts: getters?.contactsData?.contacts?.filter(e => `${e.contact_id}` !== `${contact_id}`)
    });

    // If Sidewindow is open, close it by going to the list route
    if (router.currentRoute.params.contact_id === contact_id) {
      router.push('/main/contacts/contact_list');
    }

    // Also clear the Data as well
    NavTabHelper.clearSingleNavTabDetails(contact_id);

    if (noDatabaseUpdate) {
      return;
    }

    await ContactsService.removeCompanyContact({
      contact_id: contact_id,
    });


  },
  async [types.ContactsData.FETCH.ALL]({ commit }, payload) {
    const { startRow } = payload;
    const contactsRes = await ContactsService.findContacts({
      start: startRow
    });

    // console.log(contacts.data);
    commit(types.ContactsData.SET.ALL, contactsRes.data);
  },
  async [types.SEARCH_CONTACTS]({ commit, getters }, payload) {
    const { key } = payload;
    const contactRes = await ContactsService.searchContacts({
      key
    });

    // console.log(contacts.data);
    commit(types.ContactsData.SET.ALL, {
      ...getters.contactsData,
      contacts: contactRes.data,
    });
  },
  async [types.SET_CONTACT_SEARCH_CONFIG]({ commit, getters }, payload) {
    commit(types.SET_CONTACT_SEARCH_CONFIG, payload);
  },
  async [types.ADVANCED_SEARCH_CONTACTS]({ commit, getters }, payload) {
    commit(types.SET_CONTACT_SEARCH_CONFIG, payload);

    // console.log(payload);

    const contacts = await ContactsService.advancedSearch(payload);


    // // console.log(contacts.data);
    commit(types.ContactsData.SET.ALL, {
      ...getters.contactsData,
      contacts: contacts.data,
    });
  },
  async [types.ADVANCED_SEARCH_CREATE_GROUP]({ commit, getters }, payload) {
    const contacts = await ContactsService.createGroupSearch(payload);

  },
  async [types.ContactsData.FETCH.MULTIPLE]({ commit, getters }, payload) {
    const { startRow } = payload;

    const contacts = await ContactsService.findContacts({
      start: startRow
    });

    // // console.log(getters.contactsData, {
    //   ...getters.contactsData,
    //   contacts: [
    //     ...getters.contactsData.contacts,
    //     ...contacts.data.contacts
    //   ]
    // });
    if (contacts.data.contacts && contacts.data.contacts.length > 0) {
      commit(types.ContactsData.SET.ALL, {
        ...getters.contactsData,
        contacts: [
          ...getters.contactsData.contacts,
          ...contacts.data.contacts
        ],
        startRow
      });
    }
  },
  async [types.SelectedContact.SET.SINGLE]({ commit, dispatch }, payload) {
    // console.error('types.SelectedContact.SET.SINGLE');
    const {
      flag,
      contact,
    } = payload;

    commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });
    if (!contact) {
      commit(types.SelectedContact.SET.SINGLE, {});
      return;
    }
    commit(types.SelectedContactLoading.SET.SINGLE, true);
    commit(types.SelectedContact.SET.SINGLE, createContactDetails({}));

    // const contactDetails = await ContactsService.findContactDetails({
    //   contact_id: contact.contact_id
    // });

    // const contactCustomData = await ContactsService.findCustomFields({contact_id: contact.contact_id});


    const contactDetails = await Promise.all([
      ContactsService.findContactDetails({
        contact_id: contact.contact_id
      }),
      ContactsService.findCustomFields({ contact_id: contact.contact_id }),
    ]).then(res => {
      console.log(res);
      return {
        ...(res[0].data || {}),
        fields: (res[1].data || [])
      };
    })
    dispatch(types.ContactAccountingInfo.FETCH.ALL, contact);

    commit(types.SelectedContactLoading.SET.SINGLE, false);

    commit(types.SelectedContact.SET.SINGLE, contactDetails);

    commit(types.ContactAccountingInfo.SET.ALL, {});
  },
  async [types.SelectedContactGroups.DELETE.SINGLE]({ dispatch, getters }, payload) {
    // console.log(payload);
    // commit(types.SelectedContactGroups.DELETE.SINGLE, payload);

    const selectedContact = getters.contactDetails[contact_idr()];
    const related_groups = selectedContact.related_groups.filter(e => {
      return e.group_id != payload.group_id;
    });
    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      related_groups
    });

    await GroupService.removeGroupRelation({
      contact_id: selectedContact.contact.contact_id,
      external_id: payload.group_id
    });
  },
  async [types.SelectedContactGroups.SET.ALL]({ dispatch }, payload) {
    // commit(types.SelectedContactGroups.SET.ALL, payload.data.related_groups);
    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      related_groups: payload.data.related_groups
    });
  },
  async [types.SelectedContact.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("::::", payload);
    const { name, value, promoter_id } = payload;
    // const { selectedContact } = getters;
    // commit(types.SelectedContact.UPDATE.SINGLE, { name, value });
    const selectedContact = getters.contactDetails[contact_idr()];
    const contact_id = selectedContact.contact.contact_id;

    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      contact: { ...selectedContact.contact, [name]: value }
    });

    if (name == "vat_no") {
      await InvoicesService.updateVatNo({
        contact_id,
        value
      });

      // await ContactsService.checkVatIdFlag({
      //   vat_no: value,
      //   contact_id,
      // });

      // !TODO : Do something with this validity Data
    } else if (name == 'company_legalname') {
      console.log("::::", name, value)
      const updatedData = await ContactsService.changePromoter(value, promoter_id, contact_id);
    }

    else if (["registration", "legal_form"].includes(name)) {
      await MHTTPCL.modifyJSON(undefined, contact_id, name, value, 'contacts');
    } else {
      await HttpClient.modify(
        'contact_id',
        selectedContact.contact.contact_id,
        name,
        value,
        'contacts'
      );
    }

  },

  async [types.SelectedContactRelatedContacts.SET.ALL]({ dispatch }, { contact_relations }) {
    // commit(types.SelectedContactRelatedContacts.SET.ALL, contact_relations);
    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      contact_relations
    });
  },
  // async [types.SET_CONTACT_FILES]({ commit }, { files }) {
  //   commit(types.SET_CONTACT_FILES, files);
  // },
  // [types.SelectedContactRelatedContacts.UPDATE.SINGLE]: UPDATE_RELATED_CONTACT(types.SelectedContactRelatedContacts.SET.ALL, 'selectedContact'),
  async [types.SelectedContactRelatedContacts.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const { name, value, item } = payload;

    const key = 'contact_relation_id';
    const getKVal = prop(key);
    const kVal = getKVal(item);
    const table = 'contact_relations';

    const contact_relations = (getters.contactDetails[contact_idr()]).contact_relations.map(e => {
      if (getKVal(e) == getKVal(item)) {
        return {
          ...e,
          [name]: value
        };
      }
      return e;
    });

    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      contact_relations
    });

    const updatedContactRelation = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );
  },

  // [types.SelectedContactRelatedContacts.DELETE.SINGLE]: DELETE_RELATED_CONTACT(types.SelectedContactRelatedContacts.SET.ALL, 'selectedContact'),
  async [types.SelectedContactRelatedContacts.DELETE.SINGLE]({ dispatch, getters }, payload) {
    const { contact_relation_id } = payload;
    const selectedContact = getters.contactDetails[contact_idr()];

    const contact_relations = selectedContact.contact_relations.filter(e => {
      return e.contact_relation_id != contact_relation_id;
    });

    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      contact_relations
    });

    const deletedRelation = await ContactService.deleteContactRelation({
      contactRelationId: contact_relation_id
    });
  },
  async [types.ContactFiles.DELETE.SINGLE]({ commit }, file) {
    commit(types.ContactFiles.DELETE.SINGLE, file);

    const deletedFile = await FileService.deleteFile({
      fileId: file.file_id,
      fileRelatoinId: file.file_relation_id,
    });
  },
  async [types.ContactFields.SET.ALL]({ dispatch }, payload) {
    // commit(types.ContactFields.SET.ALL, payload);    
    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      fields: payload
    });
  },
  async [types.ContactAccountingInfo.FETCH.ALL]({ commit }, payload) {
    const { contact_id } = payload;
    commit(types.ContactAccountingInfo.SET.ALL, {});

    const accountingInfo = await HttpClient.mergeRequests([ContactsService.findAccountingInfo({
      contact_id
    }), ContactsService.findInvoiceTab({
      contact_id
    })]);

    // // console.log(accountingInfo);
    commit(types.ContactAccountingInfo.SET.ALL, accountingInfo);
  },
  async [types.SET_PROVIDER_DATA]({ commit, getters }, { name, value, key }) {
    // // console.log(name, value, key, getters.accountingInfo);
    commit(types.ContactAccountingInfo.SET.ALL, set(lensPath(['payment_provider_data', key, name]))(value)(getters.accountingInfo));
    await ContactsService.updatePaymentProvider({
      kVal: getters.selectedContact.contact.contact_id,
      value: JSON.stringify({
        ...view(lensPath(['payment_provider_data', key]), getters.accountingInfo),
        [name]: value
      }),
      key
    });
  },
  async [types.DELETE_PAYMENT_PROVIDER]({ commit, getters, dispatch }, payload) {
    const { providerName } = payload;
    // commit(types.ContactAccountingInfo.SET.ALL, {
    //   ...getters.accountingInfo,
    //   payment_provider_data: omit([providerName], getters.accountingInfo.payment_provider_data)
    // });
    const selectedContact = getters.contactDetails[contact_idr()];
    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      payment_provider_data: omit([providerName], selectedContact.payment_provider_data)
    });
  },
  async [types.ContactAccountingInfo.UPDATE.ALL]({ commit, getters, dispatch }, payload) {
    const { kVal, name, value, blockModifyReq } = payload;

    const key = 'contact_id';
    const table = 'contacts';

    // commit(types.ContactAccountingInfo.SET.ALL,
    //   set(lensPath(['contact', name]))(value)(getters.accountingInfo)
    // );

    const selectedContact = getters.contactDetails[contact_idr()];
    dispatch(types.ContactDetails.UPDATE.MULTIPLE, {
      contact: { ...selectedContact.contact, [name]: value }
    });

    // // console.log(getters.accountingInfo);

    if (blockModifyReq) {
      return;
    }

    const updatedAccountingInfo = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );
  },



  ...contactGroupActions,
  ...contactFileActions,
}